import { FC, useEffect, useState } from 'react'

export const DebugMultiSelect: FC<{
  id: string
  label: string
  options: string[]
  selected: string[]
  onChange: (values: string[]) => void
}> = ({ id, label, options, selected, onChange }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!open) {
      return
    }

    const close = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null
      if (!target?.closest(`#${id}`)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [id, open])

  const toggle = (value: string) => {
    if (selected.includes(value)) {
      onChange(selected.filter((item) => item !== value))
      return
    }
    onChange([...selected, value])
  }

  const summary =
    selected.length === 0
      ? 'Tous les types'
      : `${selected.length} sélectionné${selected.length > 1 ? 's' : ''}`

  return (
    <div className="debug-field">
      <label className="debug-label" htmlFor={`${id}-toggle`}>
        {label}
      </label>
      <div className={`debug-dropdown ${open ? 'is-open' : ''}`} id={id}>
        <button
          id={`${id}-toggle`}
          className="debug-input debug-dropdown-toggle"
          type="button"
          aria-expanded={open}
          onClick={() => setOpen((current) => !current)}
        >
          <span>{summary}</span>
          <span aria-hidden="true">{open ? '▴' : '▾'}</span>
        </button>
        {open && (
          <div className="debug-dropdown-panel">
            {options.map((option) => (
              <label className="debug-dropdown-option" key={option}>
                <input
                  type="checkbox"
                  checked={selected.includes(option)}
                  onChange={() => toggle(option)}
                />
                <span>{option}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
